import * as actions from "Actions";
import * as api from "Api";

export const uploadFiles = (files = []) => (dispatch, getState) => {
  // Add meta data to  files (id, upload progress, error, ...)
  const uploads = files.map((file, i) => ({
    id: `DROPPED-${i}-${performance.now()}`,
    file,
    progress: 0,
    error: null
  }));

  // Add uploading uploads to store
  dispatch(actions.addUpload(uploads));

  // Upload the files
  uploads.forEach(upload => {
    dispatch(
      saveUpload({
        file: upload.file,
        onProgress: progress => {
          const { items } = getState().wheretobill;

          let oldUpload = null;
          let oldUploadIndex = -1;

          for (let i = 0; i < items.length; i++) {
            if (items[i].id === upload.id) {
              oldUpload = items[i];
              oldUploadIndex = i;
              break;
            }
          }

          if (!oldUpload || oldUploadIndex === -1) {
            return;
          }

          const newUpload = { ...oldUpload, progress };
          const newUploads = items.concat();
          newUploads[oldUploadIndex] = newUpload;

          dispatch(actions.setUploads(newUploads));
        }
      })
    )
      .then(() => {
        const { items } = getState().wheretobill;
        const oldUploads = items.filter(m => m.id !== upload.id);
        dispatch(actions.setUploads(oldUploads));
      })
      .catch(() => {
        const { items } = getState().wheretobill.uploading;
        const oldUploads = items.filter(m => m.id !== upload.id);
        dispatch(actions.setUploads(oldUploads));
      });
  });
};

export const saveUpload = ({ id, file, onProgress } = {}) => (
  dispatch,
  getState
) => {
  const { user, token } = getState().auth;
  const { mainEmail } = user;
  return dispatch(
    actions.saveUploads(
      api.saveUpload({
        token,
        id,
        file,
        email: mainEmail,
        onProgress
      })
    )
  );
};

export const sendUrl = url => {
  return (dispatch, getState) => {
    const { auth } = getState();
    const { token } = auth;

    return dispatch(
      actions.sendUrl(
        api.sendUrl({
          token,
          url
        })
      )
    );
  };
};

export const generateBilltiboxUrl = () => (dispatch, getState) => {
  const { user, navCommunity, token, loggedAs } = getState().auth;
  let communityId = navCommunity.id;
  if (
    loggedAs === "CLIENT" &&
    user.communities &&
    user.communities.length > 0
  ) {
    communityId = user.communities[0].id;
  }
  return dispatch(
    actions.fetchBilltoboxUrl(
      api.getBilltoboxCredential(token, user.id, communityId)
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/wheretobill.js